import {TranslateLoader} from '@ngx-translate/core';
import {catchError, map} from 'rxjs/operators';

import {ReadService} from '@common/service/read.service';
import {Observable, of} from 'rxjs';

export class ServerTranslateHttpLoader implements TranslateLoader {
  constructor(private readService: ReadService) {}

  /**
   * Gets the translations from the server
   * @param lang
   * @returns {any}
   */
  public getTranslation(lang: string): Observable<any> {
    return this.readService.queryResult('MessageList',{ params: {lang: lang ?? 'fr'}}).pipe(
      catchError((err: any) => {
        return of([]); // Return an empty array on error
      }),
      map((res: any[]) => {
        const result: any = {};
        res.forEach((element: any) => {
          result[element.code] = element.libelle;
        });

        return result;
      }),
    );
  }
}
